/* © CNES */
import * as olSource from 'ol/source';

/**
 * Open street map source.
 */
function osm() {
  return new olSource.OSM();
}

export default osm;
